import { useEffect, useState } from "react";
import ModalElement from "../../../Common/ModalElement"
import InputElement from "../../../Common/InputElement";
import ButtonElement from "../../../Common/ButtonElement";
import SearchableDropdown from "../../../Common/SearchDropdown";
import { validateFields, commonOnChange, formatDate, getDownloadableBlob, downloadAction, reverseDateFormat, parseNumber } from "../../../utils";
import { appApis, eSign, isInovize } from "../../../constants";
import { useApiRequest } from "../../../hooks/useApiRequest";
import TableElement from "../../../Common/TableElement";
import { toast } from "react-toastify";

const headerColumn = ["Select", "Vehicle No.", "Billing Amount", "Gst Amount", "Total Amount", "Billing Company"]
const GenerateInvoice = ({ show, hideModal, companies, filters, getVehicles, getInstData, currentDate }) => {
    const [details, setDetails] = useState({
        company: "",
        billing: 0,
        gstAmount: 0,
        vehicles: [],
        vehicleList: [],
        companyList: [],
        billingCompany: "",
        invoiceNo: "",
        gstApplied: "Yes",
        invoiceDate: new Date(),
        invoiceNoErr: null,
        companyErr: null
    });

    const { company, vehicles, invoiceDate, companyList, gstApplied, invoiceNo, companyErr, vehicleList, invoiceNoErr, billing, gstAmount, billingCompany } = details;
    const { request: submitRequest, loading: submitLoading } = useApiRequest();

    const onChangeHandler = (event) => commonOnChange(event, setDetails);
    const onSelectHandler = (event) => {
        const { name, value } = event.target;
        const temp = { [name]: value?.name ?? "", [`${name}Id`]: value?.id ?? "", [`${name}Err`]: null }
        const gstApplied = value?.gstType == "GST" ? "Yes" : "No";
        if (name == "company") {
            temp["gstApplied"] = gstApplied;
            getCompanyVehciles(value?.id);
        }
        setDetails(prev => ({ ...prev, ...temp }))
    };

    const submit = () => {
        validateFields(
            {
                companyErr: [company, "text"],
                invoiceNoErr: [invoiceNo, "text"]
            },
            setDetails,
            async () => {
                if (!vehicles?.length) setDetails(prev => ({ ...prev, vehiclesErr: "Select vehicles" }));
                else {
                    const fromCompany = filters?.billingCompanies?.find(item => item?.name == billingCompany);
                    const toCompany = companies?.find(item => item?.name == company);
                    const filteredVehicles = vehicleList?.filter(vehicle => vehicles.find(id => id == vehicle.vehicleid));
                    const defaultValue = filteredVehicles?.[0] || {};
                    const stamp = isInovize ? fromCompany?.companyStampUrl : eSign[String(fromCompany?.name ?? "").replaceAll(" ", "").toLowerCase() || "sbtracking"];
                    const invoiceDetails = {
                        fromCompany: {
                            name: fromCompany?.name ?? "",
                            address: fromCompany?.address ?? "",
                            gst: fromCompany?.gstNumber ?? "",
                            email: fromCompany?.email ?? "",
                            phoneNo: fromCompany?.mobileNo ?? "",
                            bankName: fromCompany?.bankName ?? "",
                            branch: fromCompany?.branchName ?? "",
                            accountNo: fromCompany?.bankAccountNo ?? "",
                            ifscCode: fromCompany?.ifscCode ?? "",
                            sacCode: isInovize ? fromCompany?.sacCode ?? "" : "998313",
                            hsnCode: isInovize ? fromCompany?.hsnCode ?? "" : "852691",
                            stampUrl: stamp,
                            digitalSignatureUrl: isInovize ? fromCompany?.digitalSignatureUrl ?? "" : null
                        },
                        toCompany: {
                            name: toCompany?.name ?? "",
                            address: toCompany?.address ?? "",
                            gst: toCompany?.gstNumber ?? "",
                            email: toCompany?.email ?? "",
                            phoneNo: toCompany?.mobileNo ?? ""
                        },
                        invoiceNo: invoiceNo,
                        date: formatDate(invoiceDate),
                        vehicles: filteredVehicles || [],
                        amount: parseNumber(billing ?? 0),
                        gstAmount: parseNumber(gstAmount ?? 0),
                        isComboCase: ((defaultValue?.billingcycle ?? "") == "Monthly" && (defaultValue?.billing_type ?? "") == "Rented"),
                        gstPercentage: (defaultValue?.gstpercentage ?? 0)
                    }

                    const invoiceBlob = await getDownloadableBlob(invoiceDetails, true);
                     // Create a File object (name it however you want)
                    const fileName = `invoice_${invoiceNo || Date.now()}.pdf`;
                    const file = new File([invoiceBlob], fileName, { type: 'application/pdf' });
                    const formData = new FormData();
                    formData.append("invoiceFile", file);
                    formData.append("companyId", toCompany?.id ?? 0);
                    formData.append("invoiceNumber", invoiceNo);
                    formData.append("invoiceDate", invoiceDetails?.date ?? "");
                    formData.append("vehicleIds", JSON.stringify(vehicles)); // Arrays should be stringified
                    formData.append("totalAmount", (invoiceDetails?.amount ?? 0) + (invoiceDetails?.gstAmount ?? 0));
                    formData.append("billingAmount", billing ?? 0);
                    formData.append("gstAmount", gstAmount ?? 0);
                    submitRequest({
                        method: "POST",
                        url: appApis.genrateVehicleInvoice,
                        body: formData,
                        onSuccess: () => {
                            downloadAction(invoiceBlob, fileName);
                            setTimeout(() => {
                                getInstData();
                                hideModal();
                            }, 1000);
                        }
                    })
                }
            }
        )
    }

    const setVehicleData = (vehicleData) => {
        const temp = [...vehicles];
        const existIndex = temp.findIndex(vehicle => vehicle == vehicleData?.vehicleid);
        let billAmt = billing;
        let gstAmt = gstAmount;
        let billComp = billingCompany;
        if (existIndex >= 0) {
            billAmt -= parseNumber(vehicleData?.billingamount ?? 0);
            gstAmt -= parseNumber(vehicleData?.gstamount ?? 0);
            temp.splice(existIndex, 1);
        } else {
            if ((billComp == "") || (billingCompany == vehicleData?.billingcompanyname)) {
                billComp = vehicleData?.billingcompanyname ?? "";
                billAmt += parseNumber(vehicleData?.billingamount ?? 0);
                gstAmt += parseNumber(vehicleData?.gstamount ?? 0);
                temp.push(vehicleData?.vehicleid)
            } else {
                toast.error("Please select vehcile with same billing company", { autoClose: 3000 });
            }
        }
        console.log(gstAmount, "gstAmount");
        setDetails(prev => ({ ...prev, vehicles: temp, billing: billAmt, gstAmount: gstAmt, billingCompany: billComp }));
    }

    const selectAll = () => {
        const temp = [];
        let billAmt = 0;
        let gstAmt = 0;
        let billComp = vehicleList?.[0]?.billingcompanyname ?? "";
        if (vehicleList?.length != vehicles?.length) {
            vehicleList?.forEach(vehicleData => {
                if ((billComp == vehicleData?.billingcompanyname)) {
                    billComp = vehicleData?.billingcompanyname ?? "";
                    billAmt += parseNumber(vehicleData?.billingamount ?? 0);
                    gstAmt += parseNumber(vehicleData?.gstamount ?? 0);
                    temp.push(vehicleData?.vehicleid)
                } else {
                    toast.error("Please select vehcile with same billing company", { autoClose: 3000 });
                }
            });
        }
        
        setDetails(prev => ({ ...prev, vehicles: temp, billing: billAmt, gstAmount: gstAmt, billingCompany: billComp }));
    }

    const getCompanyVehciles = (companyId) => {
        const toastId = toast.loading("Loading...");
        let query = companyId ? `?companyId=${companyId}` : '';
        if (currentDate?.startDate && currentDate?.endDate) query = `${query}&startDate=${reverseDateFormat(currentDate?.startDate ?? "")}&endDate=${reverseDateFormat(currentDate?.endDate ?? "")}`;
        getVehicles(query).then(response => {
            const { data } = response.data;
            setDetails(prev => ({ ...prev, vehicleList: data?.vehicles ?? [], vehicles: [] }));
        }).catch(ex => { }).finally(() => toast.dismiss(toastId))
    }

    useEffect(() => {
        setDetails(prev => ({ ...prev, companyList: companies }))
    }, [companies, filters])

    return <ModalElement FooterComponent={<div className="submit-btn text-center my-2">
        <ButtonElement text={"Submit"} cssClass="small-radius mb-1" onClick={submit} variant="btn-outline-primary" loading={submitLoading} />
    </div>} size="lg" show={show} title={"Generate Invoice"} onHide={hideModal}>
        <div className="company-request text-start">
            <div className="company-details mb-3">
                <div className="d-flex justify-content-between align-items-center me-2">
                    <h5 className="mb-3">Invoice Details</h5>
                </div>
                <div className="row w-100">
                    <div className="col-lg-6 mb-2">
                        <SearchableDropdown
                            label={"Company Name"}
                            placeholder={"Select Company Name"}
                            value={company}
                            error={companyErr}
                            options={companyList}
                            onSelect={(value) => onSelectHandler({ target: { name: "company", value } })}
                        />
                    </div>
                    <div className="col-lg-6 mb-2">
                        <InputElement
                            label={"GST Applicable"}
                            placeholder={"Enter GST Applicable"}
                            name={"gstApplied"}
                            value={gstApplied}
                            error={false}
                            disable={true}
                            onChange={null}
                        />
                    </div>
                    <div className="col-lg-6 mb-2">
                        <InputElement
                            label={"Invoice No"}
                            placeholder={"Enter Invoice No"}
                            name={"invoiceNo"}
                            value={invoiceNo}
                            error={invoiceNoErr}
                            onChange={(event) => commonOnChange(event, setDetails)}
                        />
                    </div>
                    <div className={`col-lg-6 mb-2`}>
                        <InputElement
                            type="date"
                            label={"Invoice Date"}
                            placeholder={"Enter Invoice Date"}
                            name={"invoiceDate"}
                            value={invoiceDate}
                            error={false}
                            onChange={onChangeHandler}
                        />
                    </div>
                    <div className="col-12 mb-2">
                        {vehicleList?.length > 0 ? <div className="inventory-table mb-3">
                            <div className="text-start p-2">
                                <label>
                                    <input type="checkbox" className="me-1 my-1" checked={vehicles?.length == vehicleList?.length} onClick={selectAll} />
                                    Select All
                                </label>
                            </div>
                            <TableElement data={vehicleList} columns={headerColumn} render={(tdData, index) => <tr key={index}>
                                <td>{(index ?? 0) + 1}</td>
                                <td>
                                    <input type="checkbox" checked={vehicles.includes(tdData.vehicleid ?? 0)} onChange={() => setVehicleData(tdData)} />
                                </td>
                                <td>{tdData?.vehiclenumber ?? "-"}</td>
                                <td>{tdData?.billingamount ?? 0}</td>
                                <td>{tdData?.gstamount ?? 0}</td>
                                <td>{tdData?.totalamount ?? 0}</td>
                                <td>{tdData?.billingcompanyname ?? "-"}</td>
                            </tr>} />
                        </div> : null}
                    </div>
                    {vehicles?.length ? <>
                        <div className="col-lg-4 mb-2">
                            <InputElement
                                label={"Billing Amount"}
                                placeholder={"Enter Billing Amount"}
                                name={"billing"}
                                value={billing}
                                error={false}
                                onChange={(event) => commonOnChange(event, setDetails)}
                            />
                        </div>
                        <div className="col-lg-4 mb-2">
                            <InputElement
                                label={"GST Amount"}
                                placeholder={"Enter GST Amount"}
                                name={"gstAmount"}
                                value={gstAmount}
                                error={false}
                                disable={true}
                                onChange={null}
                            />
                        </div>
                        <div className="col-lg-4 mb-2">
                            <InputElement
                                label={"Total Amount"}
                                placeholder={"Enter Total Amount"}
                                name={"totalAmount"}
                                value={parseNumber(billing ?? 0) + parseNumber(gstAmount ?? 0)}
                                error={false}
                                disable={true}
                                onChange={null}
                            />
                        </div>
                    </> : null}
                </div>
            </div>
        </div>
    </ModalElement>
}

export default GenerateInvoice;